module.exports = __webpack_public_path__ + "c85231d622f7109b86bde58242797120.png";